import { useParams } from 'react-router'

import ArticlePage from 'js/magazine-issue/View/components/ArticlePage'
import ColophonPage from 'js/magazine-issue/View/components/ColophonPage'
import CoverPage from 'js/magazine-issue/View/components/CoverPage'

import { useMagazineView } from './MagazineViewContext'

export const CoverPageRoute = () => {
    const { entity } = useMagazineView()
    return <CoverPage entity={entity} />
}

export const ColophonPageRoute = () => {
    const { entity } = useMagazineView()
    const colophon = entity.colophon.filter((field) => field.value)
    return <ColophonPage colophon={colophon} />
}

export const ArticlePageRoute = () => {
    const { entity } = useMagazineView()
    const { guid } = useParams()
    const currentArticle = entity.articles.find((a) => a.guid === guid) ?? null
    if (!currentArticle) {
        return null
    }
    return <ArticlePage container={entity} entity={currentArticle} />
}
